export default function Contacto() {
    return (
      <section id="contacto" className="bg-gray-900 text-white py-16 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6">Contacto</h2>
          <p className="text-lg text-gray-400 mb-6">
            Para consultas y servicios de pericias en incendios, contáctanos a través de los siguientes medios:
          </p>
  
          <div className="space-y-4 text-lg">
            <p>
              📞 Teléfono: <span className="text-gray-300">+5492612444001</span>
            </p>
            <p>
              📧 Correo: <span className="text-gray-300">periciascarloslaspina@gmail.com</span>
            </p>
          </div>
  
          <a
            href="https://wa.me/+5492612444001"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-block bg-green-500 text-white text-lg font-semibold px-6 py-3 rounded-lg shadow-lg hover:bg-green-600 transition duration-300"
          >
            Contactar por WhatsApp
          </a>
        </div>
      </section>
    );
  }
  